import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp5-dumbledore-daft-or-dangerous",
  name: `The Daily Prophet\n'Dumbledore: Daft or Dangerous?'`,
  nameFormatted: {
    primary: "The Daily Prophet",
    secondary: "'Dumbledore: Daft or Dangerous?'",
  },
  origin: "Harry Potter and the Order of the Phoenix",

  category: replicaCategories.harryPotter,

  versions: [Version2, Version1],
};

export default data;
